// extracted by mini-css-extract-plugin
export default {"container":"locations-count_container__1Bn0D","count":"locations-count_count__3DZka"};